import {SET_TRIPBOARD_TRANSLATIONS} from '../constants';

export default function translations(state = {}, action) {
    const {type, payload} = action;
    switch (type) {
        case SET_TRIPBOARD_TRANSLATIONS:
            return payload.translations['traveler/tripboards'].messages;
        default:
            return state;
    }
}
